import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BadgesContext = createContext({ watchedId: null, supportedId: null });
export const useBadges = () => useContext(BadgesContext);

export function BadgesProvider({ children }) {
  const [badges, setBadges] = useState({ watchedId: null, supportedId: null });
  useEffect(() => {
    api.get("/rankings/badges").then((r) => setBadges({ watchedId: r.data?.watched_id || null, supportedId: r.data?.supported_id || null })).catch(() => {});
  }, []);

  const labelFor = (id) => {
    if (id && id === badges.watchedId) return "Top vues";
    if (id && id === badges.supportedId) return "Top soutien";
    return null;
  };

  return <BadgesContext.Provider value={{ ...badges, labelFor }}>{children}</BadgesContext.Provider>;
}
